/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [sidebar-entry-space.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.02.20, 11:32
 */

import React from 'react';
import {BoxedLink} from "../../navigation/buttons/nav-buttons";
import {ImageBoxSmall} from "../../boxes/image-box-small";
import {NavigationGroup, NavigationRow} from "../../navigation/layout/nav-layout";
import SpaceAccessIcon from "../../navigation/icons/space-access-icon";
import {GalleryIcon} from "../../navigation/icons/nav-icons";

const GalleryEntrySpace = ({space, className, text=null, size='small'}) => {
    const gallerySpace = `/${space.username}/gallery/${space.spaceId}`

    return <div className={`${className ? className : ''}`}>
        <NavigationRow className='sidebar-entry-space box-light-gray'>
            <NavigationGroup>
                <BoxedLink to={gallerySpace}>
                    {space.mediaUrl && <ImageBoxSmall size={size} image={space.mediaUrl} avatar={null}/>}
                    {!space.mediaUrl && <GalleryIcon className='mr-1'/>}
                    <div className='d-flex flex-column'>
                        <div className="sidebar-space-text pl-2">{space.name}
                            <SpaceAccessIcon access={space.access}/></div>
                        {text && <div className='text-dark ml-2'>{text}</div>}
                    </div>
                </BoxedLink>
            </NavigationGroup>
        </NavigationRow>
    </div>
}

export default GalleryEntrySpace;
